import React, { useState } from "react";
import OperadoresTable from "./components/OperadoresTable";

const Operadores = () => {
  const [refresh, setRefresh] = useState(false)

  return (
    <div>
      <OperadoresTable refresh={refresh} setRefresh={setRefresh} />
    </div>
  );
};
export default Operadores;
